import { InsurerView, Modal, PDFRenderer } from "components";
import { useMatch, useNavigate, useSearch } from "react-location";

import { Action } from "components/buttons/action-button";
import { LocationGenerics } from "router/location";
import config from "config";
import { useInsurer } from "hooks/data/use-insurers";
import { wrapClick } from "utils";

export default function ViewInsurerPaymentReceiptContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { params } = useMatch<LocationGenerics>();

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="6xl"
      title="Payment Letter"
      description="Details of payment letter are shown below"
    >
      <PDFRenderer
        url={`${config.asset.uri}generate_payment_letter/${btoa(
          JSON.stringify({
            reinsurer_id: params?.reInsurer,
            offer_participant_payment_id: searchParams?.id,
          })
        )}`}
      />
    </Modal>
  );
}
